import React from 'react';
import { useTranslation } from 'react-i18next';
import CurrencyInputMC from '../../components/CurrencyInputMC';
import { hasDiscount } from '../../../util/productUtils';

const OrderProductPriceLabel = ({ product, fieldName, handleInputEdit }) => {
  const { t } = useTranslation('Orders');

  const showWholesalePriceLabel = Number(product.wholesale_price) === Number(product.unit_price) && Number(product.wholesale_price) > 0;
  const showDiscountPriceLabel = hasDiscount(product) && Number(product.discounted_price) === Number(product.unit_price) && !showWholesalePriceLabel;

  const showPriceLabel = showWholesalePriceLabel || showDiscountPriceLabel;
  let labelText = '';

  if (showWholesalePriceLabel) {
    labelText = t('itemsBox.wholesalePriceLabel');
  } else if (showDiscountPriceLabel) {
    labelText = t('itemsBox.discountedPriceLabel');
  }

  return (
    <CurrencyInputMC
      name={fieldName || 'product-unit-price'}
      label={labelText}
      useFloatingLabel={showPriceLabel}
      className="tw-text-right"
      onChange={handleInputEdit ? (e) => handleInputEdit(e, product) : undefined}
    />
  );
};

export default OrderProductPriceLabel;
